import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { ContactService } from './shared';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbService, BreadCrumbModel } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';
declare var ENV_PORTAL;

@Component({
  selector: 'app-contact',
  providers: [ContactService],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContactComponent implements OnInit {

  contactObj: any;
  callingPage: String;
  constructor(
    private router: Router,
    private ContactService: ContactService,
    private utilityService: UtilityService,
    private breadcrumb: BreadCrumbService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private chips: ChipsService
  ) { }

  ngOnInit() {
    this.callingPage = sessionStorage.getItem('callingPageName');
   sessionStorage.setItem('callingPageName', '');
     if (this.callingPage === 'support') {
      this.chips.setChips([
        {
          "label" : "Home",
          "routerLink" : "/home"
      }, 
      {
          "label" : "Support",
          "routerLink" : "/support"
      }, 
      {
          "label" : "Contact Us",
          "routerLink" : "/contact"
      }]);
     } else {
      this.chips.setChips([
        {
          "label" : "Home",
          "routerLink" : "/home"
      }, 
      {
          "label" : "Contact Us",
          "routerLink" : "/contact"
      }]);
    }
    // tslint:disable-next-line:max-line-length
    const url = (ENV_PORTAL === 'fnabc') ? this.utilityService.getEnvConfig().fncontactdetails : this.utilityService.getEnvConfig().contactdetails;
    this.ContactService.getContactDetails(url)
      .subscribe(contactrespobj => {
        this.contactObj = contactrespobj;
      }, error => {
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error);
      });
    this.ContactService.createPageLoadProperties('', '');
  }

  handleError(error) {
    throw error;
  }

}
